<template>
  <div class="landing">
    <img class="landing-bg" src="@assets/img/cac.png" />
    <div class="top">
      <img src="@assets/img/cac/title_bg.png" />
      <a href="https://regen.cacshow.com/2403CACenVR/index.html#/login?ExhID=5498" class="txt">
        <i class="iconfont icon-5-renyuandengji"></i>
        <p>Exhibition Visitor Registration</p>
      </a>
    </div>
    <div class="con_wrap">
      <div class="content">
        <img @click="goToHome('3bc3ed3d-d84e-40d6-be92-910905ba0576')" class="CAC" src="@assets/img/cac/CAC.png" />
        <img @click="goToHome('33ffaaa0-6c0d-4878-b96e-d22573d3b038')" class="CACE" src="@assets/img/cac/CACE.png" />
        <img @click="goToHome('68da03a5-8127-43b0-903c-97ccb982c429')" class="CAA" src="@assets/img/cac/CAA.png" />
        <img @click="goToHome('5fe797f0-a87e-46a6-ae72-48205eda9086')" class="SEED" src="@assets/img/cac/SEED.png" />
        <img @click="goToHome('63af2701-17c3-4fb1-b826-aca9228adcc3')" class="FSHOW" src="@assets/img/cac/FSHOW.png" />
      </div>
    </div>
    <div class="layout_txt">
      <img :src="imgUrl" preview="1" :large="imgUrl">
      Layout
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "landing",
  components: {
  },
  data () {
    return {
      imgUrl: 'https://img.zhanshangxiu.com/showonline/file/202401/20240109/e1f03ebb633d42f5a9d9b8e2d8da7099.png'
    }
  },
  created () {
  },
  mounted () {
    this.$nextTick(() => {
      //图片查看器打开后，打印本次查看器的实例（事件、方法、属性的示例）
      this.$preview.on("imageLoadComplete", (e, item) => { });
    })

  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId: 'getExhibitionId'
    })
  },
  methods: {
    ...mapActions({
      LinkFooter: 'linkTo/LinkFooter'
    }),
    goToHome (id) {
      this.$store.commit('setExhibitionId', id)
      let opt = {
        url: `/home/${id}`
      };
      this.LinkFooter(opt);
    },
    openLayout () {

    },
  }
};
</script>

<style lang="scss" scoped>
.landing {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: url("../../assets/img/cac.png") no-repeat;
  background-size: cover;
  position: relative;
  &-bg {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
  }
  .layout_txt {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    color: #fff;
    font-size: 0.22rem;
    bottom: 0.6rem;
    z-index: 2;
    display: block;
    border-bottom: 1px solid #fff;
    padding-bottom: 0.06rem;
    width: 1rem;
    text-align: center;
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      z-index: 1;
    }
  }
  .top {
    width: 100%;
    height: 0.95rem;
    background: rgba(#000, 0.14);
    display: flex;
    align-items: center;
    position: relative;
    justify-content: space-between;
    z-index: 2;
    padding: 0 0.36rem;
    img {
      display: block;
      width: 2.36rem;
    }
    .txt {
      color: #fff;
      display: flex;
      align-items: center;
      i {
        font-size: 0.28rem;
      }
      p {
        font-size: 0.2rem;
        margin-left: 0.1rem;
      }
    }
  }
  .con_wrap {
    width: 100%;
    height: calc(100vh - 0.95rem);
    position: relative;
    z-index: 2;
    .content {
      width: 6.02rem;
      height: 6.37rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      img {
        position: absolute;
        width: 1.52rem;
        &.CAC {
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          height: 2.02rem;
        }
        &.CACE {
          top: 1.74rem;
          right: 0;
          height: 2.02rem;
        }
        &.CAA {
          right: 1rem;
          bottom: 0;
          height: 2.12rem;
        }
        &.SEED {
          left: 1rem;
          bottom: 0;
          height: 2.12rem;
        }
        &.FSHOW {
          left: 0;
          top: 1.74rem;
          justify-content: 1.99rem;
        }
      }
    }
  }
}
</style>

